import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { Context, Transitions } from "../../types"

export const detailsTrayState: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({ openDetailsTray: true }),
  on: {
    OPEN_EDIT: {
      target: "edit_modal",
      actions: "selectedClassRecord"
    },
    OPEN_DELETE: {
      target: "delete_modal",
      actions: "selectedClassRecord"
    },
    CLOSE: {
      target: "idle",
      actions: assign<Context>({
        openDetailsTray: false,
        selectedClassRecord: null
      })
    }
  }
}
